module.exports = __webpack_public_path__ + "static/media/c7bannerModul2_small.f548902e.jpg";